import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface StatDownIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const StatDownIcon = ({ className, ...props }: StatDownIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 10L12 18L15 15L20 20"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M16 4V12M16 12L19 9M16 12L13 9"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default StatDownIcon;
